<template>
    <div style="height: 100%;">
        <v-tabs v-model="active">
            <v-tab href="#tab-1" :key="1" v-if="fs.show(activePtyType+'.Properties.View')" :disabled="fs.disabled(activePtyType+'.Properties.View')">{{ $t( 'message.element_props' ) }}</v-tab>
            <v-tab href="#tab-2" :key="2" v-show="bomVis">
                <span v-if="!isReq">{{ $t( 'message.bom_tb' ) }}</span>
                <span v-else>{{ $t( 'message.bom_req_tb' ) }}</span>
                <ToolButton 
                    icon="push_pin" ghost
                    :class="bomFixed? '' : 'inactive-button'"
                    :tool-tip="bomFixed?'message.tab_menu_unfix':'message.tab_menu_fix'" 
                    v-on:click.stop="()=>{bomFixed = !bomFixed}"
                    />
                <ToolButton 
                    icon="close" ghost danger
                    tool-tip="message.tab_menu_close" 
                    v-on:click.stop="()=>{bomVis = false; active = 'tab-1'; }"
                    />
            </v-tab>
            <v-tab href="#tab-3" :key="3" v-show="treeVis">
                {{ $t( 'message.node_tree_tb' ) }}
                <ToolButton 
                    icon="close" ghost danger
                    tool-tip="message.tab_menu_close" 
                    v-on:click.stop="()=>{treeVis = false; active = 'tab-1'; }"
                />
            </v-tab>
            <v-tab href="#tab-44" :key="4" v-show="copyVis">
                <span style="overflow: hidden; text-overflow: ellipsis;">{{ globalState.curCopyFolderName }}</span>
                <ToolButton 
                    icon="close" ghost danger
                    tool-tip="message.tab_menu_close" 
                    v-on:click.stop="()=>{copyVis = false; active = 'tab-1'; }"
                />
            </v-tab>
            <v-tab-item value="tab-1">
                <Split direction="vertical" :gutterSize="8" @onDragEnd="(s)=>{fs.saveConfigValue('systemPropertiesPanelHeight', s[0]); return s;}" style="height:100%; display: flex; flex-direction: column;">
                    <SplitArea :size="fs.show(activePtyType+'.UserProperties.View')?fs.configValue('systemPropertiesPanelHeight'):100" :minSize="0">
                        <PropertiesSheet :feature-prefix="activePtyType+'.Properties'" :itemsData="sysItemsData"/>
                    </SplitArea>
                    <SplitArea v-if="fs.show(activePtyType+'.UserProperties.View')" :size="100-fs.configValue('systemPropertiesPanelHeight')" :minSize="0">
                        <PropertiesSheet :feature-prefix="activePtyType+'.UserProperties'" :itemsData="userItemsData"/>
                    </SplitArea>
                </Split>
            </v-tab-item>
            <v-tab-item value="tab-2">
                <tree-root-with-load-view :path="bomPath" :fixed="bomFixed"></tree-root-with-load-view>
            </v-tab-item>
            <v-tab-item value="tab-3">
                <tree-root-view :path="treePath"></tree-root-view>
            </v-tab-item>
             <v-tab-item value="tab-44">
                 <node-list-view></node-list-view>
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
    import { Split, SplitArea } from 'vue-split-panel';

    import PropertiesSheet from './PropertiesSheet.vue'
    import TreeRoot from '../Tree/Root.vue'
    import TreeRootWithLoad from '../Tree/RootWithLoad.vue'
    import NodeList from '../NodeList.vue'
    import ToolButton from '../ToolButton.vue'

    import FeaturesSet from "@/utils/features"
    import{ conf } from '../../utils/confTruePLM';

const commonGroups = [
    { aData: 'ids', title: 'Identifiers', nameFld: 'role_name', valFld: 'id', 
              addValFld: 'org_context', cols: [ 'Role', 'ID', 'Context' ] },
    { aData: 'classified_as', title: 'Classified by', nameFld: 'role_name', 
              valFld: 'class_name', cols: [ 'Role', 'Class' ] },
    { aData: 'described_as', title: 'Described as', nameFld: 'role_name', 
              valFld: 'text', cols: [ 'Role', 'Text' ] },
    { aData: 'datetimes', title: 'Timestamps', nameFld: 'role_name', 
              valFld: 'dt_text', cols: [ 'Role', 'Date' ] },
    { aData: 'persons', title: 'Persons', nameFld: 'role_name', valFld: 'person',
        addValFld: 'org', cols: [ 'Role', 'Name', 'Organisation' ] },
    
    { aData: 'rels', title: 'Links', nameFld: 'caption', addValFld: 'parent_child',
              valFld: 'related.name', cols: [ 'Role', 'Node', 'Type' ] },
    { aData: 'parents', title: 'Parents', valFld: 'node_name', cols: [ 'Path' ] },
    { aData: 'orgs', title: 'Organisations', nameFld: 'caption', 
              valFld: 'organization.title', cols: [ 'Role', 'Organisation' ] }
  ];

const groupPtys = {
  Node: commonGroups,
  Document: commonGroups,
  Product: []
}

export default {
  name: 'PropertiesPanel',
  data () 
  {
    return {
        fs: FeaturesSet,
        active: null,
        activePtyType: "Node",
        bomVis: false,
        treeVis: false,
        copyVis: false,
        isReq: false,
        treePath: null,
        bomPath: null,
        bomFixed: false,
        globalState: this.$globalStore.state,
        node: {},
        model: {},
        sysItemsData: [],
        userItemsData: [],
        lists:{
          element_types: {data: [], itemKey:"urn", loading: false, failed: false, loader: ()=>conf.getTypesTree('urn:rdl:epm-std:breakdown_element_type')},
          users: {data: [], loading: false, failed: false, loader: this.getUsersEnum},
          disciplines: {data: [], loading: false, failed: false, loader:()=>this.getTypesEnum('urn:rdl:epm-std:project_discipline')},
          sources: {data: [], loading: false, failed: false, loader:()=>this.getTypesEnum('urn:rdl:epm-std:Source_of_information')},
          docstatuses: {data: [], loading: false, failed: false, loader:()=>this.getChildTypes('urn:rdl:epm-std:Document_status')},
          doctypes: {data: [], loading: false, failed: false, loader:()=>this.getChildTypes('urn:rdl:epm-std:Document_content_type')}
        },
        favPtys: {
          Node: [ 
            { name: 'Name', value: 'name', editType:"text", rules:[v => !!v || this.$t( 'message.value_required' )], saveNewValue:(node, v)=>{
              return conf.renameNode( node, v, this.$globalStore.setActTimestamp()).then(rez => {
                if (rez) this.updateRootVer( rez.updated_node_version );
               node.name = v;
              })
            }}, 
            { name: 'Type', 
              value: 'element_type', 
              viewAdapter: (v) => this.$utils.clearType(v),
              rules:[],
              disabled: (node) => node.is_requirement || !node.parent,
              editType:"selecttree", 
              listData:"element_types", 
              saveNewValue:(node, v)=>{
                const data = {name:node.name, descr: node.description, type: v, tmpl: null};
                return conf.editNode( node, data, this.$globalStore.setActTimestamp() ).then( ( rez ) => {
                  if( rez ) this.updateRootVer( rez.updated_node_version );
                  node.element_type = v;
                })
              }
            },
            { name: 'Description', value: 'description', editType:"textarea", rules:[], parse: true , 
              viewAdapter: (v) => v?.replaceAll('\r\n', '\n'), saveNewValue:(node, v)=>{
              const data = {name:node.name, descr: v, type: node.element_type, tmpl: null};
              return conf.editNode( node, data, this.$globalStore.setActTimestamp() ).then( ( rez ) => {
                if( rez ) this.updateRootVer( rez.updated_node_version );
                node.description = v;
                this.initData();
              })
            }},
        //  { name: 'ID', value: 'id' },
            { name: 'Created by', value: 'created_by_user' },
            { name: 'Created date', value: 'date_created', viewAdapter: (dt)=>this.$utils.getLocalDateFromUTC( dt ) },
            { name: 'Last modified by', value: 'last_modified_by_user' },
            { name: 'Last modified date', value: 'date_last_modified', viewAdapter: (dt)=>this.$utils.getLocalDateFromUTC( dt ) },
        //  { name: 'Phase', value: 'phase' },
        //  { name: 'Version', value: 'version_id' },
        //  { name: 'Links', value: 'rels' },
        //  { name: 'Organisations', value: 'orgs' },
        //  { name: 'Hash', value: 'hash' }
          ],
          Document: [
            { name: 'Title', value: 'title', class_name: 'title' }, 
            { name: 'Name', value: 'file_name' }, 
            { name: 'Description', value: 'description' },
        //  { name: 'ID', value: 'id' }, 
            { name: 'Size', value: 'size' },
            { name: 'Created by', value: 'created_by_user' },
            { name: 'Created date', value: 'date_created', viewAdapter: (dt)=>this.$utils.getLocalDateFromUTC( dt ) },
            { name: 'Last modified by', value: 'last_ver_user' },
            { name: 'Last modified date', value: 'last_ver_date', viewAdapter: (dt)=>this.$utils.getLocalDateFromUTC( dt ) },
            { name: 'Revision', value: 'last_ver_id' },
            { name: 'Phase', value: 'last_ver_phase', viewAdapter: (v) => this.$utils.clearType(v)  },
            { name: 'Approver', value: 'approver', editType:"select", listData:"users", saveNewValue:(node, val)=>{
              this.$eventBus.$emit( 'updateFileProps', { node, props: [ {type:'Approver', val }], isClass: true } );
            } },
            { name: 'Release manager', value: 'release_manager', editType:"select", listData:"users", saveNewValue:(node, val)=>{
              this.$eventBus.$emit( 'updateFileProps', { node, props: [ {type:'Release manager', val }], isClass: true } );
            } },
            { name: 'Responsible', value: 'responsible', editType:"select", listData:"users", saveNewValue:(node, val)=>{
              this.$eventBus.$emit( 'updateFileProps', { node, props: [ {type:'Responsible', val }], isClass: true } );
            } },
            { name: 'Reviewer', value: 'reviewer', editType:"select", listData:"users", saveNewValue:(node, val)=>{
              this.$eventBus.$emit( 'updateFileProps', { node, props: [ {type:'Reviewer', val }], isClass: true } );
            } },
            { name: 'Discipline', value: 'discipline', editType:"select", listData:"disciplines", viewAdapter: (v) => this.$utils.clearType(v), saveNewValue:(node, val)=>{
              this.$eventBus.$emit( 'updateFileProps', { node, props: [ {type:'urn:rdl:epm-std:project_discipline', val }], isClass: true } );
            } },
            { name: 'External version', value: 'external_version', class_name: 'ext_ver' },
            { name: 'Format', value: 'data_type' },
          //{ name: 'Project phase', value: 'project_phase', class: 'urn:rdl:epm-std:project_phase' },
            { name: 'RID references', value: 'rid', class_name: 'rid'  },
            { name: 'Source', value: 'source', editType:"select", listData:"sources", viewAdapter: (v) => this.$utils.clearType(v), saveNewValue:(node, val)=>{
              this.$eventBus.$emit( 'updateFileProps', { node, props: [ {type:'urn:rdl:epm-std:Source_of_information', val }], isClass: true } );
            }  },
            { name: 'Status', value: 'status', viewAdapter: (v) => this.$utils.clearType(v), editType:"select", listData:"docstatuses", saveNewValue:(node, val)=>{
              this.$eventBus.$emit( 'updateFileProps', { node, props: [ {type:'urn:rdl:epm-std:Document_status', val }], isClass: true } );
            } },
            { name: 'Type', value: 'document_type', viewAdapter: (v) => this.$utils.clearType(v),  editType:"select", listData:"doctypes", saveNewValue:(node, val)=>{
              this.$eventBus.$emit( 'updateFileProps', { node, props: [ {type:'urn:rdl:epm-std:Document_content_type', val }], isClass: true } );
            } }
          ],
          Product: [
            { name: 'Name', value: 'name' }, 
            { name: 'Type', value: 'part_type', viewAdapter: (v) => this.$utils.clearType(v)  },
            { name: 'Description', value: 'description' },
        //  { name: 'ID', value: 'id' },
            { name: 'Created by', value: 'created_by' },
            { name: 'Created date', value: 'created' },
            { name: 'Version', value: 'ver' },
            { name: 'Domain', value: 'domain', viewAdapter: (v) => this.$utils.clearType(v) },
            { name: 'Stage', value: 'stage', viewAdapter: (v) => this.$utils.clearType(v) }
          ]
        }
    };
  },
  methods: {
    updateRootVer: function(v){
      this.$eventBus.$emit( 'procRowMenuCmd', [ 'updateRootVer', v ] );
    },
    openRels( type ){
      let self = this;
      this.$modalDlg.sysDlgs.relsListDlg.open( this.model, type ).then( ( rel ) => {
        if( rel && rel.related ) {
          conf.getNodePath( rel.related.instance_id ).then( ( rez ) => {
              if( rez && rez.tree_path_to_element )
                  self.$eventBus.$emit( 'procRowMenuCmd', [ 'gotoNode', rez.tree_path_to_element ] ); 
          }).catch( ( err ) => {
            self.$eventBus.$emit( 'queryError', err );
          });
        } else self.$eventBus.$emit( 'updateCurFolder' );
      });
    },
    openMaterial( item ){
      let key = item.type + ' ref.';
      let ref = null;
      for( let i = 0; i < this.model.properties.length; i++ )
      {
          if( this.model.properties[ i ].name === key )
          {
              ref = this.model.properties[ i ].val;
              break;
          }
      }
  
      //  console.log( ref );
      this.$modalDlg.sysDlgs.propsListDlg.open( item.val_view, { rep: 'TruePLMprojectsRep', ref: ref } );
    },
    gotoParent( prn ){
      this.$eventBus.$emit( 'procRowMenuCmd', [ 'gotoNode', prn.paths[ 0 ].ids ] );
    },
    getUsersEnum(){
      return conf.getProjectUsersEnum().then( data => data.map(e => ({value: e.val, text: e.txt})));
    },
    getChildTypes(type){
      return conf.getChildTypesInContext( type ).then( data => data.map(e => ({value: e, text: this.$utils.clearType(e)})));
    },
    getTypesEnum(type){
      return conf.getChildTypes( type ).then( data => data.map(e => ({value: e, text: this.$utils.clearType(e)})));
/*          self.$utils.getEnum( data ).forEach( ( opt ) =>
          {
              opts.push( opt.val );
          });
          item.obj = { type: item.class, domain: 'urn:owl:oneOf', options: opts };
          self.openUpdateProp( item, propList );
*/
    },
    initData: function(){
      if (!this.activePtyType) return;

      let ind = 1;
      let emptyFields = [];
      this.sysItemsData = [];
      const userItemsData = [];
      const favProps = this.favPtys[this.activePtyType];

      ///system properties
      favProps.forEach( ( item ) =>{
        let val = this.model[ item.value ];
        let propDesc = {
          num: ind++, 
          ...item, value:undefined,
          val, 
          val_view: item.viewAdapter? item.viewAdapter(val) : (''+val),
          readonly: this.$globalStore.state.actVer>0 || this.$globalStore.state.projLock
        };

        if (item.parse) propDesc.urlList = this.$utils.getURLData( val );

        if (propDesc.editType && propDesc.saveNewValue) {
          if (typeof item.listData === 'string') {
            const list = this.lists[item.listData];
            propDesc.itemKey = list.itemKey;
            propDesc.itemText = list.itemText;
            propDesc.listData = list.data;
          }
          propDesc.disabled = (typeof item.disabled === 'function') ? item.disabled(this.model) : item.disabled;
          propDesc.onChanged = (pitem, value) => {
            //console.log("changed value for "+pitem.name, value);
            item.saveNewValue(this.model, value)
            pitem.val = value;
            pitem.val_view = item.viewAdapter ? item.viewAdapter(value) : (''+value);
          }
        }
        this.sysItemsData.push(propDesc);
      });

      /*if (this.activePtyType === 'Document'){
        const propObj = {num: ind++, name: 'Hash',  type_view: 'T', readonly: true};
        propObj.val_view = conf.getHash( this.model.instance_id ).then(hash => hash?.result);
        this.sysItemsData.push(propObj);
      }*/

      ind = 0;
      groupPtys[this.activePtyType]?.forEach( info => {
        if( this.model[ info.aData ] ) {
          ind++;
          this.model[ info.aData ].forEach( el => {
            let val = this.$utils.getValByPath( el, info.valFld );
            if( info.aData === 'datetimes' )
                val = this.$utils.getLocalDateFromUTC( val );
            else if( info.aData === 'parents' && el.paths[ 0 ] )
                val = el.paths[ 0 ].names.join( ' / ' );

            let addVal = this.$utils.getValByPath( el, info.addValFld );
            if( info.aData === 'rels' )
                addVal = ( addVal === 'CHILD' ) ? 'direct' : 'backward';
            let noName, leftActions, isLink, onClick;
            if( info.aData === 'parents' ) { 
              noName = true;
              if (el.node_id !== this.globalState.curFolderInfo?.instance_id){
                isLink = true; 
                onClick = ()=> this.gotoParent( el );
                leftActions = [{icon: 'visibility', toolTip:'message.prop_rel_btn', onClick }]
              }
            }

            this.sysItemsData.push( { groupData: ind + '_' + info.aData, groupInfo: info.title, noName, 
                name: this.$utils.getValByPath( el, info.nameFld ), groupDataVal: info.aData, isLink, onClick,
                val_view: ''+val, val: val, type_view: addVal, type: addVal, cols: info.cols, leftActions } );
          });
        }
      });

      ind = 1;
///user properties
      if( this.fs.show(this.activePtyType+'.UserProperties.View') && (this.model.parent || this.model.isSearch) )
      {
        let usedProps = [];
        for( let i = 0; this.model.properties && i < this.model.properties.length; i++ )
            usedProps.push( i );
        
        let typePart = this.$utils.noGUID( this.model.document_type || this.model.part_type || this.model.element_type );
        conf.getPropsByName( typePart ).then( ( fullPList ) => {
          for( var i = 0; i < fullPList.length; i++ ) {
            let item = fullPList[ i ];
            let name = item.name || this.$utils.clearType( item.urn );

            if( "NameInList" === name ) continue;

            let item_val = {};
            if( this.model.properties )
            {
                for( var j = 0; j < this.model.properties.length; j++ )
                {
                    if( this.$utils.noGUID( this.model.properties[ j ].name ) === item.urn )
                    {
                        item_val = this.model.properties[ j ];
                        usedProps[ j ] = -1;
                        break;
                    }
                }
            }

            let tView = this.$utils.getPropType( item.domains ) || 'T';

            let val_view = this.$utils.procPropVal( item_val.val, tView );

            const edit = (!( item.editable_for && item.editable_for.length > 0 ) || 
                              this.globalState.curUserRole === 'urn:rdl:epm-std:project_manager')
                              && !this.$utils.isReadOnlyType( item.domains );

            let unit, unit_code;
            if( tView === 'N' ){
              unit_code = item_val.unit;
              unit = this.$utils.clearType( item_val.unit );
              if (!unit_code && item.units?.length > 0) {
                unit_code = item.units[0];
                unit = this.$utils.clearType(unit_code);
              }
              item_val.val = item_val.num_val;
              val_view = item_val.num_val?.toString();
            }

            let propObj = { num: ind++, name: name, type: item.urn, type_view: tView,
                    val_view, val: item_val.val, unit_code, unit, isMandatory: !item.optional_flag };

            if (edit) {
              const commonChangeHandler = (pitem, value)=>{
                if (!item_val.val && !value) return Promise.resolve();
                return this.updatePropertyValue(item.urn, value, item_val.val, tView).then(()=>{
                  item_val.val = propObj.val = value;
                  propObj.val_view = this.$utils.procPropVal( item_val.val, tView );
                  this.applyChanges();
                })
              }
              propObj.onClear = ()=>{
                //console.log('clear')
                return this.clearPropertyValue(item.urn, item_val.val, item_val.unit).then(()=>{
                  item_val.val = propObj.val = null;
                  propObj.val_view = '';
                  this.applyChanges();
                })
              }
              switch(tView){
                case 'N':
                  propObj.editType = "number";
                  propObj.fieldMask = "numeric";
                  //propObj.fieldMask = "numeric?min=-100&max=100&step=10&prefix='NOK '";

                  propObj.unitsList = item.units?.map(u => ({value: u, text: this.$utils.clearType(u)}));
                  propObj.onUnitChanged = (pitem, value)=>{
                    return this.updatePropertyValue(item.urn, item_val.val||0, item_val.val, "N", value, item_val.unit).then(()=>{
                      item_val.unit = propObj.unit_code = value;
                      propObj.val_view = value.toString();
                      this.applyChanges();
                    });
                  }
                  propObj.onChanged = (pitem, value)=>{
                    if (!Number.isFinite(value)) return Promise.resolve();
                    return this.updatePropertyValue(item.urn, value, item_val.val, "N", propObj.unit_code, item_val.unit).then(()=>{
                      item_val.num_val = item_val.val = propObj.val = value;
                      propObj.val_view = value.toString();
                      this.applyChanges();
                    });
                  };
                  break;
                case 'B':
                  propObj.editType = "checkbox";
                  propObj.val = val_view?.toLowerCase() === 'true' ? true : (val_view?.toLowerCase() === 'false'? false : undefined);
                  propObj.onChanged = (pitem, value)=>{
                    return this.updatePropertyValue(item.urn, value?"True":"False", item_val.val, tView).then(()=>{
                      propObj.val = value;
                      item_val.val = propObj.val_view = value?"True":"False";
                      this.applyChanges();
                    });
                  };
                  break;
                case 'DT':
                case 'D':
                  propObj.editType = "datetime";
                  propObj.dateType = tView === 'DT' ? 'datetime-local' : 'date';
                  propObj.onChanged = commonChangeHandler;
                  break;
                case 'E':
                  propObj.editType = "select";
                  propObj.listData = item.options?.map(t => ({text: this.$utils.clearType(t)})) || [];
                  propObj.onChanged = commonChangeHandler;
                  break;
                case 'T':
                  propObj.urlList = this.$utils.getURLData( val_view );
                  propObj.editType = "text";
                  propObj.onChanged = commonChangeHandler;
                  break;
                case 'A':
                  propObj.isLink = true;
                  propObj.editable = true;
                  propObj.rightActions=[{
                    icon: "vertical_align_top", 
                    toolTip: "message.prop_upload_btn",
                    disabled: this.$globalStore.state.actVer>0,
                    onClick: () => this.$eventBus.$emit( 'uploadAggrPropData', { node: this.model, prop: item } )
                  },{
                    icon: "vertical_align_bottom", 
                    toolTip: "message.prop_download_btn",
                    disabled: this.$globalStore.state.actVer>0,
                    onClick: () => this.$eventBus.$emit( 'downloadAggrPropData', { node: this.model, prop: item } )
                  }];
                  propObj.onClick = () => {
                    let proj = conf.getProj();
                    let url = '#/listgr?';
                    let propUrn = encodeURIComponent( item.urn );
                    window.open( url + '&rep=' + proj.repository + '&model=' + proj.in_project.project_model_id 
                          + '&node=' + this.model.instance_id + '&prop=' + propUrn + '&role=' + proj.userType, '_blank' );
                  }
                  if (!propObj.val_view) { propObj.val_view = "Empty"; propObj.onClick = undefined; propObj.isLink = false; }
                  break;
                default: 
                  break;
              }
            }

            if(this.$utils.isDerivedProp( item.super_types ) ) {
              propObj.type_view = 'd' + tView;
            }

            if (item.expression || this.$globalStore.state.actVer>0 || this.$globalStore.state.projLock) {
              propObj.readonly = true;
              propObj.editable = false;
            }

            if (this.fs.disabled(this.activePtyType+'.UserProperties.View')) {
              propObj.disabled = true;
            }

            if( propObj.isMandatory && !propObj.val_view )
                emptyFields.push( propObj.name );

            userItemsData.push( propObj );
          }

          if( this.$globalStore.state.actVer > 0)
          {
              usedProps.forEach( i =>
              {
                  if( i > -1 )
                  {
                      let prop = this.model.properties[ i ];
                      let tView = this.$utils.getPropType( ( prop.value_domain || '' ).split( ',' ) ) || 'T';
                      let pVal = this.$utils.procPropVal( prop.val, tView );

                      let urlList = null;
                      let isLink = false, onClick;

                      if( pVal && tView === 'N' )
                      {
                            prop.val = prop.num_val;
                            pVal = prop.num_val.toString();
                      }
                      else if( tView === 'A' )
                      {
                        isLink = true;
                        onClick = () => {
                          let proj = conf.getProj();
                          let url = '#/listgr?';
                          let propUrn = encodeURIComponent( prop.name );
                          window.open( url + '&rep=' + proj.repository + '&model=' + proj.in_project.project_model_id 
                            + '&node=' + this.model.instance_id + '&prop=' + propUrn + '&role=' + proj.userType, '_blank' );
                        }
                      }
                      else
                        urlList = this.$utils.getURLData( pVal );

                      if( prop.is_derived ) tView = 'd' + tView;

                      let propObj = { num: ind++, name: this.$utils.clearType( prop.name ), type: prop.name, 
                          unit_code: prop.unit, type_view: tView, val_view: pVal, val: prop.val, 
                          unit: this.$utils.clearType( prop.unit ), urlList, isLink,
                          readonly: true, isMandatory: false, deleted: true, onClick };
                      userItemsData.push( propObj );
                  }
              });
          }
          this.userItemsData = userItemsData;
          this.$eventBus.$emit( 'propStatus', { emptyFields: emptyFields, node: this.model } );
        }).catch( ( err ) => {
          this.userItemsData = [];
          this.$eventBus.$emit( 'queryError', err );
        }); 
      }
    },
    updatePropertyValue(type, val, oldValue, type_view, unit, oldUnit){
      const typeNode = this.activePtyType === "Document" ? 'file' 
        : (this.activePtyType === "Product" ? 'prod' : '');

      const objs = [{type, type_view, val, unit_code: unit || null, obj: {val: oldValue, unit: oldUnit || null}}];
      return conf.updateNodeProps( this.model, objs, typeNode, this.$globalStore.setActTimestamp() ).then( ( rez ) =>{
        rez && this.$eventBus.$emit("updateRootVer", rez.updated_node_version)
      }).catch(err => {
        this.$eventBus.$emit( 'queryError', err );
        throw new Error("Saving failed");
      })
    },
    clearPropertyValue(type, oldValue, oldUnit){
      const typeNode = this.activePtyType === "Document" ? 'file' 
        : (this.activePtyType === "Product" ? 'prod' : '');

      const objs = [{type, delete:true, val:oldValue, unit_code: oldUnit || null, obj: {val: oldValue, unit: oldUnit || null}}];
      return conf.updateNodeProps( this.model, objs, typeNode, this.$globalStore.setActTimestamp() ).then( ( rez ) =>{
        rez && this.$eventBus.$emit("updateRootVer", rez.updated_node_version)
        this.$eventBus.$emit("procRowMenuCmd", ["applyNodeChange", this.model]);
      }).catch(err => {
        this.$eventBus.$emit( 'queryError', err );
      })
    },
    applyChanges(){
      this.$eventBus.$emit("procRowMenuCmd", ["applyNodeChange", this.model]);
    },
    loadList(){
      for(const listName in this.lists){
        const list = this.lists[listName];
        list.loading = true;
        list.loader().then(data => {
          list.data = data || []; 
        }).catch(err => {
          list.failed = true;
          this.$eventBus.$emit( 'queryError', err );
        }).finally(()=>{list.loading=false; this.initData()});
      }
    }
  },
  components: {
      'tree-root-view': TreeRoot,
      'tree-root-with-load-view': TreeRootWithLoad,
      'node-list-view': NodeList,
      Split,
      SplitArea,
      PropertiesSheet,
      ToolButton
  },
  beforeMount: function()
  {
    
  },

  mounted: function()
  {
      this.$eventBus.$on( 'showPathAsTree', ( path ) => {
        this.treePath = path;
        this.treeVis = true;
        this.active = 'tab-3';
      });
      this.$eventBus.$on( 'showBOMFromPath', ( path ) => {
        this.isReq = path[ path.length - 1 ].is_requirement;
        this.bomPath = path;
        this.bomVis = true;
        this.active = 'tab-2';
      });
      this.$eventBus.$on( 'selectedModel', () => {
        this.bomVis = false;
        this.bomFixed = false;
        this.treeVis = false;
        this.active = 'tab-1';
        this.activePtyType = 'Node';
        //console.log('selectedModel');
        if( this.$refs.tabs )
          this.$refs.tabs.onResize(); 
        this.loadList();
      });
      
      this.$eventBus.$on( 'updateNode', (data) => {
        //console.log('updateNode', data);
        this.activePtyType = 'Node';
        if( !this.bomFixed || this.active !== 'tab-2' ){
          this.active = 'tab-1';
        }
        this.node = this.model = data;
        this.initData();
      });
      this.$eventBus.$on( 'showSelProps', (data) => {
        //console.log('showSelProps', data);
        this.activePtyType = 'Node';
        if( !this.bomFixed || this.active !== 'tab-2' )
          this.active = 'tab-1';
        this.node = this.model = data;
        this.initData();
      });

      this.$eventBus.$on( 'updateFile', ( data ) => {
        this.activePtyType = 'Document';
        if( !this.bomFixed || this.active !== 'tab-2' )
          this.active = 'tab-1';
        
        this.node = data.node;
        this.model = data.file;
        this.initData();
      });
      
      this.$eventBus.$on( 'updateProd', ( data ) => {
        this.activePtyType = 'Product';
        if( !this.bomFixed || this.active !== 'tab-2' )
          this.active = 'tab-1';

        this.model = data;
        if (data.part){
          this.model = data.part;
          this.model.elemID = data.elemID;
          this.model.parent = data.parent;
        }
        this.initData();
      });

      this.$eventBus.$emit( 'reInitState', {} );
  },
  beforeDestroy: function()
  {
      this.$eventBus.$off( 'showPathAsTree' );
      this.$eventBus.$off( 'showBOMFromPath' );
      this.$eventBus.$off( 'selectedModel' );
      
      this.$eventBus.$off( 'updateNode' );
      this.$eventBus.$off( 'updateFile' );
      this.$eventBus.$off( 'showSelProps' );
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.v-tabs{
    height: 100%;
    display: flex;
    flex-direction: column;
}
.v-tabs >>> div[role=tablist]{
    min-height: 48px;
}
.v-tabs >>> .v-window__container, .v-tabs >>> .v-window-item{
    height: 100%;
}

.v-tabs >>> .v-tabs-items{
    flex: 1 1 auto;
}

.v-tabs >>>.v-tab{
  font-size: 18px;
  font-weight: bold;
  color: #777 !important;
  text-transform: initial;
  letter-spacing:initial;
}

.v-tabs >>> .v-tabs-slider-wrapper{
  color: var(--brand-main-color);
}
.inactive-button >>> i{
    color: #a6a6a6 !important;
    font-size: 16px !important;
}
</style>
